import UCalgaryLogo from "../../public/ucalgaryLogo.png";
import Circle from "../LogoSVG/Circle";

export const TAMobile = () => {
  return (
    <div className="">
      <div className="flex flex-col justify-start">
        <p className="mb-1 font-medium text-[18px]">
          Graduate Teaching Assistant - University of Calgary
        </p>
        <div className="flex flex-row mt-2 mb-2">
          <p className="text-gray-4">
            SENG 401: Software Architecture (Winter '26)
          </p>
        </div>

        <div className="flex flex-row items-start mb-2">
          <div className="text-gray-4 ">
            SENG 533: Software Performance Evaluation (Winter '26)
          </div>
        </div>

        <div className="flex flex-row items-start mb-2">
          <div className="text-gray-4 ">
            ENCM 335: Programming Fundamentals (Fall '25, '26)
          </div>
        </div>

        <div className="flex flex-row items-start mb-2">
          <div className="text-gray-4 ">
            ENDG 233: Programming with Data (Fall '26)
          </div>
        </div>
      </div>
    </div>
  );
};
